import React from "react";
import Hero from "@/components/Hero";
import FAQ from "@/components/FAQ";
import Marquee from "@/components/Marquee";
import BookingCTA from "@/components/BookingCTA";
import {
    Manifesto,
    EditorialSplit,
    BenefitsGrid,
    DualCallout,
    RelatedLinks,
} from "@/components/Editorial";
import { HERO_IMG, PHOTO } from "@/data/site";

export default function Gelinium() {
    return (
        <>
            <Hero
                eyebrow="Ricostruzione e rinforzo unghie"
                title={["Gelinium", "a Livorno."]}
                subtitle="Un trattamento dedicato alla ricostruzione delle unghie, ideale per ottenere mani curate, unghie resistenti e un risultato naturale."
                subtitleMobile="Ricostruzione unghie per un risultato naturale."
                imgDesktop={HERO_IMG.gelinium.d}
                imgMobile={HERO_IMG.gelinium.m}
                primaryCta={{ label: "Prenota un appuntamento", href: "/contatti" }}
                secondaryCta={{ label: "Richiedi informazioni", href: "/contatti" }}
            />

            <div className="bg-ivory pt-8 pb-4"></div>

            <Manifesto
                number="01"
                eyebrow="Che cos'è"
                title="Un trattamento dedicato alla ricostruzione e al rinforzo delle unghie."
                body={[
                    "Il Gelinium è pensato per chi desidera mani sempre curate e unghie dall'aspetto naturale.",
                    "Può essere una soluzione per chi ha unghie fragili che tendono a spezzarsi facilmente, oppure per chi desidera una forma più armoniosa o una lunghezza personalizzata.",
                    "L'obiettivo non è semplicemente allungare le unghie, ma creare un risultato equilibrato, resistente ed elegante.",
                ]}
            />

            <EditorialSplit
                number="02"
                eyebrow="Perché sceglierlo"
                title="Ricostruire, rinforzare, valorizzare."
                image={PHOTO.curaMani}
                imageAlt="Gelinium"
                accentBg="bg-blush/40"
                body={[
                    "Le unghie sono continuamente esposte a piccoli urti, detergenti, attività lavorative e gesti quotidiani che possono renderle più fragili.",
                    "Il Gelinium permette di ricostruire e rinforzare l'unghia, migliorandone l'aspetto e offrendo una maggiore resistenza rispetto all'unghia naturale.",
                    "È una scelta apprezzata da chi desidera avere mani ordinate più a lungo senza dover intervenire frequentemente sulla manicure.",
                ]}
            />

            <BenefitsGrid
                eyebrow="I vantaggi"
                title="Estetica, praticità, resistenza."
                subtitle="Ogni trattamento viene personalizzato e adattato alle caratteristiche dell'unghia naturale, così da valorizzare le mani senza risultare artificiale."
                items={[
                    {
                        title: "Unghie più resistenti",
                        body: "Per chi ha unghie che si spezzano facilmente, la ricostruzione contribuisce a rendere l'unghia più resistente agli urti e alle sollecitazioni quotidiane.",
                    },
                    {
                        title: "Forma uniforme e naturale",
                        body: "È possibile creare una forma più armoniosa e proporzionata, rispettando sempre l'aspetto naturale della mano.",
                    },
                    {
                        title: "Lunghezza personalizzata",
                        body: "Con il Gelinium possiamo definire insieme la lunghezza più adatta al tuo stile, alle abitudini quotidiane e alle caratteristiche delle tue unghie.",
                    },
                    {
                        title: "Una manicure curata più a lungo",
                        body: "Le unghie risultano uniformi, resistenti e piacevoli da vedere, riducendo la necessità di intervenire frequentemente.",
                    },
                    {
                        title: "Base ideale per Nail Art",
                        body: "Se lo desideri, il Gelinium può essere completato con una Nail Art semplice ed elegante, per rendere le unghie ancora più personalizzate.",
                    },
                    {
                        title: "Attenzione ai dettagli",
                        body: "Ogni trattamento viene eseguito con attenzione ai dettagli, rispettando la forma naturale delle mani e cercando sempre un risultato armonioso.",
                    },
                ]}
            />

            <DualCallout
                eyebrow="La scelta giusta"
                title="Il Gelinium è il trattamento giusto per te?"
                subtitle="Prima di iniziare valutiamo sempre la situazione dell'unghia naturale, così da consigliarti la soluzione più adatta e offrirti un risultato armonioso."
                cards={[
                    {
                        title: "È il trattamento ideale se…",
                        list: [
                            "vuoi rinforzare unghie fragili o che si spezzano;",
                            "cerchi una ricostruzione dall'aspetto naturale;",
                            "desideri migliorare la forma delle unghie;",
                            "vuoi una lunghezza personalizzata;",
                            "cerchi una manicure ordinata più a lungo;",
                            "vuoi valorizzare le mani con un risultato elegante.",
                        ],
                    },
                    {
                        title: "Ogni ricostruzione è personalizzata",
                        body: "Ogni unghia è diversa e merita un trattamento dedicato. Analizziamo la forma naturale, ascoltiamo le tue esigenze e realizziamo una ricostruzione che rispetti il tuo stile.",
                    },
                ]}
            />

            <EditorialSplit
                number="03"
                eyebrow="Perché Spazio Isa"
                title="Precisione, cura, eleganza."
                image={PHOTO.mani}
                imageAlt="Spazio Isa mani"
                accentBg="bg-rose-powder/40"
                body={[
                    "Da oltre 15 anni Spazio Isa si prende cura delle mani delle proprie clienti con professionalità, precisione e attenzione ai dettagli.",
                    "Crediamo che una ricostruzione ben eseguita non debba apparire artificiale, ma valorizzare le mani attraverso una forma armoniosa e una finitura curata.",
                    "Ogni cliente riceve una consulenza personalizzata per scegliere la lunghezza, la forma e il risultato estetico più adatto.",
                ]}
            />

            <BookingCTA
                title="Prenota il tuo trattamento Gelinium."
                subtitle="Contattaci per ricevere maggiori informazioni o per fissare un appuntamento: saremo felici di consigliarti la soluzione più adatta."
            />

            <FAQ
                items={[
                    {
                        q: "Che cos'è il Gelinium?",
                        a: "Un trattamento dedicato alla ricostruzione e al rinforzo delle unghie, pensato per ottenere un risultato resistente, armonioso e dall'aspetto naturale.",
                    },
                    {
                        q: "È indicato per chi ha unghie fragili?",
                        a: "Sì. È una soluzione molto apprezzata da chi ha unghie che tendono a spezzarsi o sfaldarsi facilmente.",
                    },
                    {
                        q: "Posso scegliere la lunghezza delle unghie?",
                        a: "Certamente. La lunghezza viene definita insieme all'estetista, tenendo conto delle tue preferenze e della forma naturale.",
                    },
                    {
                        q: "Il risultato è naturale?",
                        a: "Sì. Privilegiamo ricostruzioni eleganti e armoniose, studiate per valorizzare le mani senza creare un effetto artificiale.",
                    },
                    {
                        q: "È possibile aggiungere una Nail Art?",
                        a: "Sì. Se lo desideri, la ricostruzione può essere completata con decorazioni semplici ed eleganti, personalizzate in base ai tuoi gusti.",
                    },
                    {
                        q: "Quanto dura il Gelinium?",
                        a: "La durata varia in base alla crescita naturale delle unghie e alle abitudini personali. Durante l'appuntamento riceverai indicazioni sui richiami.",
                    },
                    {
                        q: "Dove si trova Spazio Isa?",
                        a: "In Via A. Minghi 30, nel quartiere Coteto, a Livorno.",
                    },
                ]}
            />

            <RelatedLinks
                items={[
                    { label: "Nail Art", to: "/nail-art" },
                    { label: "Estetica", to: "/estetica" },
                    { label: "Prodotti", to: "/prodotti" },
                    { label: "Contatti", to: "/contatti" },
                ]}
            />
        </>
    );
}
